const catalog = {
	financePeriodicity: { 1: 'Annual', 2: 'Quarterly', 3: 'Monthly' },
	currency: {
		EUR: 'Euro',
		USD: 'Dollar',
		CHF: 'Swiss franc',
		XOF: 'CFA franc',
		TND: 'Dinar',
		GBP: 'Pound sterling',
		INR: 'Rupee',
		KES: 'Shilling',
		SAR: 'Riyal',
		MXN: 'Peso',
		SEK: 'Crown',
	},
	langOption: {
		fr: 'French (default)',
		en: 'English (default)',
		es: 'Spanish',
		de: 'German',
		it: 'Italian',
		nl: 'Dutch',
		fi: 'Finnish',
		eu: 'Basque',
		ca: 'Catalan',
		backoffFr: 'French (default)',
		backoffEn: 'English (default)',
		backoffEs: 'Spanish',
		backoffDe: 'German',
		backoffIt: 'Italian',
		backoffNl: 'Dutch',
	},
	frontLang: {
		Français: 'French (default)',
		Anglais: 'English (default)',
		Espagnol: 'Spanish',
		Allemand: 'German',
		Italien: 'Italian',
		Néerlandais: 'Dutch',
		Finnois: 'Finnish',
		Basque: 'Basque',
		Catalan: 'Catalan',
	},
	identifiant: {
		aucun: 'None',
		qrcode: 'Otipass number as QR code',
		clair: 'Otipass number in clear text (8 digits)',
		unique: 'Unique Otipass ID (sequential)',
		serie: 'Serial number (transport)',
		calypso: 'Calypso number (transport)',
		amc: 'AMC number',
		autre: 'Other',
	},
	frequence: {
		synchroInit: 'Initial sync (once at project start)',
		synchroMens: 'Daily periodic sync',
		other: 'Other',
	},
	placeholders: {
		tel: 'E.g. +33 1 23 45 67 89',
		email: 'E.g. name@example.com',
	},
	countries: {
		France: 'France',
		Belgique: 'Belgium',
		Luxembourg: 'Luxembourg',
		Suisse: 'Switzerland',
		Allemagne: 'Germany',
		Espagne: 'Spain',
		Italie: 'Italy',
		Portugal: 'Portugal',
		'Pays-Bas': 'Netherlands',
		Irlande: 'Ireland',
		Autriche: 'Austria',
		Danemark: 'Denmark',
		Suède: 'Sweden',
		Finlande: 'Finland',
		Grèce: 'Greece',
		Pologne: 'Poland',
		Hongrie: 'Hungary',
		Tchéquie: 'Czechia',
		Slovaquie: 'Slovakia',
		Slovénie: 'Slovenia',
		Roumanie: 'Romania',
		Bulgarie: 'Bulgaria',
		Estonie: 'Estonia',
		Lettonie: 'Latvia',
		Lituanie: 'Lithuania',
		Croatie: 'Croatia',
		Malte: 'Malta',
		Chypre: 'Cyprus',
		'République tchèque': 'Czech Republic',
	},
	pj: {
		id: 'ID document',
		home: 'Proof of address',
		tax: 'Tax notice',
		other: 'Other',
	},
	payment: {
		SystemPay: 'SystemPay',
		Atos: 'Atos',
		Payrexx: 'Payrexx',
		Twint: 'Twint (via Payrexx)',
		PayPal: 'PayPal',
		Monetico: 'Monetico',
		OrangeMoney: 'OrangeMoney',
		PayFip: 'PayFip',
		Paytrail: 'Paytrail',
		PayBox: 'PayBox',
		Avizi: 'Avizi',
		Wave: 'Wave',
		Autre: 'Other',
	},
	featuresForm: {
		compte: 'Family account',
		pj: 'Supporting document management',
		captcha: 'Captcha / anti-bot',
		rgpd: 'GDPR consent',
	},
	featuresBoutique: {
		passCourt: 'Short-term pass purchase',
		passLong: 'Long-term pass purchase',
		renew: 'Long-term pass renewal',
		tarif: 'Preferential renewal rate',
		multi: 'Multiple pass order',
		cadeau: 'Gift card purchase',
		promo: 'Add/remove a promo code',
		quick: 'Quick purchase without account',
		activation: 'Arrival date entry for automatic pass activation',
		cb: 'Card/PayPal payment',
		otipoints: 'Payment in points (otipoints)',
		cheque: 'Cheque payment',
		chequeVac: 'Holiday voucher payment',
		facility: 'Instalment payment',
		recurrent: 'Recurring payment (subscriptions)',
		loyalty: 'Loyalty programme (otipoints)',
		eticket: 'Instant e-ticket',
		post: 'Postal physical media',
		pickup: 'Pickup at point of sale',
		invoice: 'Invoicing',
		multiDev: 'Multi-currency',
		multiLang: 'Multi-language',
		deferred: 'Deferred payment',
		transfer: 'Bank transfer',
		sso: 'SSO (FranceConnect)',
	},
	champsFormula: {
		package: { label: 'Package', title: 'Plan label', ph: 'E.g. annual pass' },
		reference: { label: 'Ref.', title: 'Reference', ph: 'P1' },
		duree: { label: 'Duration', title: 'Number of days the pass can be used', ph: '365' },
		periode: { label: 'Period', title: 'Rolling period', ph: '365' },
		tarifAdulte: { label: 'Adult', title: 'Adult price (€)' },
		tarifEnfant: { label: 'Child', title: 'Child price (€)' },
		accompagnants: { label: 'Comp.', title: 'Number of companions' },
	},
	userData: {
		'Civilité': 'Title',
		'Nom': 'Last name',
		'Prénom': 'First name',
		'Date de naissance': 'Date of birth',
		'Adresse email': 'Email address',
		'N° rue': 'Street no.',
		'Rue': 'Street',
		"Complément d'adresse": 'Address line 2',
		'Code postal': 'Postal code',
		'Ville': 'City',
		'Pays': 'Country',
		'Tél. 1': 'Tel. 1',
		'Tél. 2': 'Tel. 2',
	},
};

export default catalog;
